export default function setLocation(overlay, location) {
  switch (overlay.type) {
    case 'circle':
      overlay.setCenter(location)
      break
    case 'polygon':
      overlay.setPaths(location)
      break
    case 'polyline':
      overlay.setPath(location)
      break
    case 'wall':
      overlay.setPath(location)
      break
    case 'rectangle':
      overlay.setBounds(location)
      break
    case 'label':
      overlay.setCenter(location)
      break
  }
}



// WEBPACK FOOTER //
// ./src/helpers/markups/setLocation.js